import { createReducer, on } from '@ngrx/store';

import * as notificationActions from '@notifications/store/actions/notifications.actions';
import { NotificationsState } from '@notifications/store/states/notifications.state';
import * as settingsActions from '@settings/store/actions/settings.actions';

const initialState = new NotificationsState();

export const notificationsReducer = createReducer(
    initialState,
    on(notificationActions.setNotifications, (state, { notifications }) => ({ ...state, notifications })),
    on(notificationActions.setActiveTab, (state, { tab }) => ({ ...state, activeTab: tab })),
    on(notificationActions.showOnlyUnviewedFilterChanged, (state) => ({ ...state, isShowOnlyUnviewedNotifications: !state.isShowOnlyUnviewedNotifications })),
    on(notificationActions.resetState, () => ({ ...initialState })),
    on(notificationActions.setAppointmentsVisualizationAllowed, (state, { isAllowed }) => ({ ...state, appointmentsVisualizationAllowed: isAllowed })),
    on(settingsActions.loadSettingsSuccessful, (state, { layoutSettings }) => ({ ...state, isShowOnlyUnviewedNotifications: layoutSettings.showOnlyUnreadNotifications })),
);